module.exports = __webpack_public_path__ + "media/images/category_icons/narration-bfe0b8257d40bac519b31678cbd13513.svg";